import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// public routing
const TermsAndConditions = Loadable(lazy(() => import('views/pages/TermsAndConditions')));
const EndUserLicenseAgreement = Loadable(lazy(() => import('views/pages/EndUserLicenseAgreement')));
const PrivacyPolicy = Loadable(lazy(() => import('views/pages/PrivacyPolicy')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
  path: '/',
  element: (
    <NavMotion>
      <MinimalLayout />
    </NavMotion>
  ),
  children: [
    {
        path: '/terms',
        element: <TermsAndConditions />
    },
    {
        path: '/eula',
        element: <EndUserLicenseAgreement />
    },
    {
        path: '/privacy',
        element: <PrivacyPolicy />
    }
  ]
};

export default PublicRoutes;
